<ng-container *ngIf="dialogComponentVisible">
    <app-dialog [title]="dialogTitle" [disabled]="preSelection === null" [template]="buscadorespeciesList" (accepted)="onDialogAccepted($event)"></app-dialog>

    <ng-template #buscadorespeciesList>
        <app-buscadorespecies-list [dialogMode]="true" (selected)="onSelected($event)"></app-buscadorespecies-list>
    </ng-template>
</ng-container>

<div class="animated container-fluid">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4>{{ title }} Restricción de Productos de Exportación</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos de la Restricción
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="inpPaisDestino">País de destino</label>

                                            <ng-select [items]="listPais"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPaisDestino"
                                                       loadingText="Cargando..."
                                                       [loading]="!(listPais)"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País de destino --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdPaisDestino')"
                                                       appendTo="body"
                                                       [readonly]="restriccion && !cloneMode">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisDestino', 'required')">
                                                El país de destino es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="intDescripcion">Fecha de Creación</label>
                                            <input formControlName="FechaCreacion" name="FechaCreacion" class="form-control" readonly inputStyleClass="form-control" [ngClass]="displayFieldCss('FechaCreacion')">
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="intDescripcion">Fecha de Baja</label>
                                            <input formControlName="FechaBaja" name="FechaBaja" class="form-control" readonly inputStyleClass="form-control" [ngClass]="displayFieldCss('FechaBaja')">
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field" for="inpActiva" style="margin-bottom: -3px;">Activa</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="Activa" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedEspecie = !isCollapsedEspecie" [attr.aria-expanded]="!isCollapsedEspecie" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Especie Asociada
                                    <i *ngIf="isCollapsedEspecie" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedEspecie" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDatos" [ngbCollapse]="isCollapsedEspecie">
                                    <div class="row">

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label required-field" for="IdGrupoDescripcion">Grupo</label>
                                            <input readonly formControlName="IdGrupoDescripcion" name="IdGrupoDescripcion" class="form-control" inputStyleClass="form-control" type="text">

                                            <div id="validationIdEspecieFeedback" class="form-invalid" *ngIf="isFieldInvalid('IdEspecie', 'cannotBeNullOrZero', true)">
                                                Especie obligatoria. Utilice el buscador de Código Eppo para seleccionarla
                                            </div>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label required-field" for="intFormaDescripcion">Forma</label>
                                            <input readonly formControlName="IdFormaDescripcion" name="IdFormaDescripcion" class="form-control" inputStyleClass="form-control" type="text" value="">
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="inpNombreComun">Nombre Común</label>
                                            <input readonly formControlName="NombreComun" name="NombreComun" class="form-control" inputStyleClass="form-control" type="text" value="">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="inpNombreCientifico">Nombre Científico</label>
                                            <input readonly formControlName="NombreCientifico" name="NombreCientifico" class="form-control" inputStyleClass="form-control" type="text" value="">
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="inpCodigoEppo">Código Eppo</label>
                                            <div class="input-group">
                                                <input readonly formControlName="CodigoEppo" name="CodigoEppo" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('CodigoEppo')" type="text" value="" style="margin-right: 4px;">
                                                <span class="input-group-btn">
                                                    <button [disabled]="form.disabled || (restriccion && !cloneMode)" name="btnSearchCodigoEppo" class="btn btn-list btn-secondary" type="button" title="Buscar Código Eppo - Nombre Científico" (click)="onSelectEspecie()"><i class="fa fa-search"></i></button>
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
